/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const usePolicyId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let policyNumber = urlParams.get('policyno');
  let userVid = urlParams.get('vuid');
  let payoutId = urlParams.get('pid');

  if (policyNumber) {
    policyNumber = String(policyNumber).trim();
  }

  if (userVid) {
    userVid = String(userVid).trim();
  }

  if (payoutId) {
    payoutId = String(payoutId).trim();
  }

  return {
    policyNumber,
    userVid,
    payoutId,
  };
};
